import { render } from "./SecurityIcons.vue?vue&type=template&id=703572b4"
const script = {}

import "./SecurityIcons.vue?vue&type=style&index=0&id=703572b4&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__